import Vue from 'vue'
import {
  Pagination,
  Menu,
  Submenu,
  Link,
  MenuItem,
  Backtop
} from 'element-ui';

Vue.use(Pagination)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Link)
Vue.use(Backtop)